// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Approve Modal Container */
.ApproveLeaveModal_approveModal__mt6TF {
  margin: 16px !important;
}

.ApproveLeaveModal_approveModal__mt6TF .MuiDialog-paper {
  margin: 16px !important;
  width: 100% !important;
  max-width: 540px !important;
  border-radius: 12px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid #e5e7eb !important;
}

/* Modal Header */
.ApproveLeaveModal_modalHeader__aOBDV {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-bottom: 8px !important;
  border-bottom: 1px solid var(--input, #e2e8f0) !important;
}

.ApproveLeaveModal_modalTitle__PWRn5 {
  color: var(--Slate-700, #334155);

  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
}

.ApproveLeaveModal_closeButton__fY45z {
  color: #6b7280 !important;
}

.ApproveLeaveModal_closeButton__fY45z:hover {
  background-color: #f3f4f6 !important;
}

/* Modal Content */
.ApproveLeaveModal_modalContent__kvIo4 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.ApproveLeaveModal_confirmationText__Ir1cf {
  color: var(--Slate-800, #1e293b);

  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  margin-bottom: 8px !important;
}

.ApproveLeaveModal_warningText__VhybW {
  color: var(--Slate-500, #64748b);

  font-family: var(--font-family-font-sans, Inter);
  font-size: 14px; /* changed to numeric */
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* approx 142.857% */
}

/* Modal Actions */
.ApproveLeaveModal_modalActions__TduXh {
  padding: 24px 32px !important;
  border-top: 1px solid #f3f4f6 !important;
  gap: 16px !important;
}

/* Cancel Button */
.ApproveLeaveModal_cancelButton__oPYh8 {
  border: none !important;
  color: #374151 !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 7px 24px !important;
  border-radius: 8px !important;
  background-color: rgba(241, 245, 249, 1) !important;
}

.ApproveLeaveModal_cancelButton__oPYh8:hover {
  border-color: #9ca3af !important;
  background-color: #e5e7eb !important;
}

/* Approve Button */
.ApproveLeaveModal_approveButton__Fnrwh {
  background-color: #644ee5 !important; /* Indigo-600 */
  color: #fff !important;
  text-transform: none !important;
  font-weight: 500 !important;
  padding: 7px 24px !important;
  border-radius: 8px !important;
  box-shadow: none !important;
}

.ApproveLeaveModal_approveButton__Fnrwh:hover {
  background-color: #644ee5 !important;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3) !important;
}

/* Responsive adjustments */

/* Tablet (1024px) */
@media (max-width: 1024px) {
  .ApproveLeaveModal_modalTitle__PWRn5 {
    font-size: 19px;
  }
  .ApproveLeaveModal_confirmationText__Ir1cf {
    font-size: 15px;
  }
  .ApproveLeaveModal_approveModal__mt6TF .MuiDialog-paper {
    max-width: 480px !important;
  }
}
@media (max-width: 600px) {
  .ApproveLeaveModal_approveModal__mt6TF .MuiDialog-paper {
    margin: 8px !important;
    max-width: calc(100vw - 16px) !important;
  }

  .ApproveLeaveModal_modalActions__TduXh {
    padding: 8px 16px 16px 16px !important;
    gap: 12px !important;
  }

  .ApproveLeaveModal_cancelButton__oPYh8,
  .ApproveLeaveModal_approveButton__Fnrwh {
    padding: 10px 20px !important;
  }
}
/* Mobile (768px) */
@media (max-width: 768px) {
  .ApproveLeaveModal_approveModal__mt6TF .MuiDialog-paper {
    margin: 12px !important;
    width: 95% !important;
    max-width: 420px !important;
  }

  .ApproveLeaveModal_modalHeader__aOBDV,
  .ApproveLeaveModal_modalContent__kvIo4,
  .ApproveLeaveModal_modalActions__TduXh {
    padding: 16px !important;
  }

  .ApproveLeaveModal_modalTitle__PWRn5 {
    font-size: 18px;
  }

  .ApproveLeaveModal_confirmationText__Ir1cf {
    font-size: 15px;
  }

  .ApproveLeaveModal_warningText__VhybW {
    font-size: 13px;
  }

  .ApproveLeaveModal_modalActions__TduXh {
    flex-direction: column-reverse;
    gap: 12px !important;
  }

  .ApproveLeaveModal_cancelButton__oPYh8,
  .ApproveLeaveModal_approveButton__Fnrwh {
    width: 100% !important;
    padding: 10px 20px !important;
  }
}

/* Small Mobile (480px) */
@media (max-width: 480px) {
  .ApproveLeaveModal_approveModal__mt6TF .MuiDialog-paper {
    margin: 8px !important;
    width: 100% !important;
    max-width: 100% !important;
    border-radius: 10px !important;
  }

  .ApproveLeaveModal_modalHeader__aOBDV {
    padding: 14px 12px !important;
  }

  .ApproveLeaveModal_modalTitle__PWRn5 {
    font-size: 17px;
  }

  .ApproveLeaveModal_modalContent__kvIo4 {
    padding: 12px !important;
  }

  .ApproveLeaveModal_confirmationText__Ir1cf {
    font-size: 14px;
    line-height: 20px;
  }

  .ApproveLeaveModal_warningText__VhybW {
    font-size: 12px;
  }

  .ApproveLeaveModal_modalActions__TduXh {
    padding: 12px !important;
    gap: 10px !important;
  }

  .ApproveLeaveModal_cancelButton__oPYh8,
  .ApproveLeaveModal_approveButton__Fnrwh {
    width: 100% !important;
    padding: 10px !important;
    font-size: 15px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperMostAdmin/GatePass/components/ApproveLeaveModal.module.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;EAC9B,gGAAgG;EAChG,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;EACxB,yCAAyC;EACzC,8BAA8B;EAC9B,8BAA8B;EAC9B,yDAAyD;AAC3D;;AAEA;EACE,gCAAgC;;EAEhC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA,kBAAkB;AAClB;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;;EAEhC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,SAAS;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;;EAEhC,gDAAgD;EAChD,eAAe,EAAE,uBAAuB;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,oBAAoB;AACzC;;AAEA,kBAAkB;AAClB;EACE,6BAA6B;EAC7B,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,uBAAuB;EACvB,yBAAyB;EACzB,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,mDAAmD;AACrD;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,mBAAmB;AACnB;EACE,oCAAoC,EAAE,eAAe;EACrD,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,yDAAyD;AAC3D;;AAEA,2BAA2B;;AAE3B,oBAAoB;AACpB;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,2BAA2B;EAC7B;AACF;AACA;EACE;IACE,sBAAsB;IACtB,wCAAwC;EAC1C;;EAEA;IACE,sCAAsC;IACtC,oBAAoB;EACtB;;EAEA;;IAEE,6BAA6B;EAC/B;AACF;AACA,mBAAmB;AACnB;EACE;IACE,uBAAuB;IACvB,qBAAqB;IACrB,2BAA2B;EAC7B;;EAEA;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,8BAA8B;IAC9B,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,6BAA6B;EAC/B;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,sBAAsB;IACtB,sBAAsB;IACtB,0BAA0B;IAC1B,8BAA8B;EAChC;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,oBAAoB;EACtB;;EAEA;;IAEE,sBAAsB;IACtB,wBAAwB;IACxB,0BAA0B;EAC5B;AACF","sourcesContent":["/* Approve Modal Container */\n.approveModal {\n  margin: 16px !important;\n}\n\n.approveModal :global(.MuiDialog-paper) {\n  margin: 16px !important;\n  width: 100% !important;\n  max-width: 540px !important;\n  border-radius: 12px !important;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;\n  border: 1px solid #e5e7eb !important;\n}\n\n/* Modal Header */\n.modalHeader {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center !important;\n  padding-bottom: 8px !important;\n  border-bottom: 1px solid var(--input, #e2e8f0) !important;\n}\n\n.modalTitle {\n  color: var(--Slate-700, #334155);\n\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 30px; /* 150% */\n}\n\n.closeButton {\n  color: #6b7280 !important;\n}\n\n.closeButton:hover {\n  background-color: #f3f4f6 !important;\n}\n\n/* Modal Content */\n.modalContent {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n\n.confirmationText {\n  color: var(--Slate-800, #1e293b);\n\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px; /* 150% */\n  margin-bottom: 8px !important;\n}\n\n.warningText {\n  color: var(--Slate-500, #64748b);\n\n  font-family: var(--font-family-font-sans, Inter);\n  font-size: 14px; /* changed to numeric */\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* approx 142.857% */\n}\n\n/* Modal Actions */\n.modalActions {\n  padding: 24px 32px !important;\n  border-top: 1px solid #f3f4f6 !important;\n  gap: 16px !important;\n}\n\n/* Cancel Button */\n.cancelButton {\n  border: none !important;\n  color: #374151 !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 7px 24px !important;\n  border-radius: 8px !important;\n  background-color: rgba(241, 245, 249, 1) !important;\n}\n\n.cancelButton:hover {\n  border-color: #9ca3af !important;\n  background-color: #e5e7eb !important;\n}\n\n/* Approve Button */\n.approveButton {\n  background-color: #644ee5 !important; /* Indigo-600 */\n  color: #fff !important;\n  text-transform: none !important;\n  font-weight: 500 !important;\n  padding: 7px 24px !important;\n  border-radius: 8px !important;\n  box-shadow: none !important;\n}\n\n.approveButton:hover {\n  background-color: #644ee5 !important;\n  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.3) !important;\n}\n\n/* Responsive adjustments */\n\n/* Tablet (1024px) */\n@media (max-width: 1024px) {\n  .modalTitle {\n    font-size: 19px;\n  }\n  .confirmationText {\n    font-size: 15px;\n  }\n  .approveModal :global(.MuiDialog-paper) {\n    max-width: 480px !important;\n  }\n}\n@media (max-width: 600px) {\n  .approveModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    max-width: calc(100vw - 16px) !important;\n  }\n\n  .modalActions {\n    padding: 8px 16px 16px 16px !important;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .approveButton {\n    padding: 10px 20px !important;\n  }\n}\n/* Mobile (768px) */\n@media (max-width: 768px) {\n  .approveModal :global(.MuiDialog-paper) {\n    margin: 12px !important;\n    width: 95% !important;\n    max-width: 420px !important;\n  }\n\n  .modalHeader,\n  .modalContent,\n  .modalActions {\n    padding: 16px !important;\n  }\n\n  .modalTitle {\n    font-size: 18px;\n  }\n\n  .confirmationText {\n    font-size: 15px;\n  }\n\n  .warningText {\n    font-size: 13px;\n  }\n\n  .modalActions {\n    flex-direction: column-reverse;\n    gap: 12px !important;\n  }\n\n  .cancelButton,\n  .approveButton {\n    width: 100% !important;\n    padding: 10px 20px !important;\n  }\n}\n\n/* Small Mobile (480px) */\n@media (max-width: 480px) {\n  .approveModal :global(.MuiDialog-paper) {\n    margin: 8px !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    border-radius: 10px !important;\n  }\n\n  .modalHeader {\n    padding: 14px 12px !important;\n  }\n\n  .modalTitle {\n    font-size: 17px;\n  }\n\n  .modalContent {\n    padding: 12px !important;\n  }\n\n  .confirmationText {\n    font-size: 14px;\n    line-height: 20px;\n  }\n\n  .warningText {\n    font-size: 12px;\n  }\n\n  .modalActions {\n    padding: 12px !important;\n    gap: 10px !important;\n  }\n\n  .cancelButton,\n  .approveButton {\n    width: 100% !important;\n    padding: 10px !important;\n    font-size: 15px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"approveModal": `ApproveLeaveModal_approveModal__mt6TF`,
	"modalHeader": `ApproveLeaveModal_modalHeader__aOBDV`,
	"modalTitle": `ApproveLeaveModal_modalTitle__PWRn5`,
	"closeButton": `ApproveLeaveModal_closeButton__fY45z`,
	"modalContent": `ApproveLeaveModal_modalContent__kvIo4`,
	"confirmationText": `ApproveLeaveModal_confirmationText__Ir1cf`,
	"warningText": `ApproveLeaveModal_warningText__VhybW`,
	"modalActions": `ApproveLeaveModal_modalActions__TduXh`,
	"cancelButton": `ApproveLeaveModal_cancelButton__oPYh8`,
	"approveButton": `ApproveLeaveModal_approveButton__Fnrwh`
};
export default ___CSS_LOADER_EXPORT___;
